module.exports = __webpack_public_path__ + "img/1-1.04f8a706.jpg";